// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Actions
import { setTargetRatesShowRecessions } from './show-recessions.actions';
export const showRecessions = createReducer(false, on(setTargetRatesShowRecessions, (state, action) => {
    return action.showRecessions;
}));
